export class CreateInputModel {}
